import { render, staticRenderFns } from "./JcTicketDetails.vue?vue&type=template&id=336411f2&scoped=true&"
import script from "./JcTicketDetails.vue?vue&type=script&lang=js&"
export * from "./JcTicketDetails.vue?vue&type=script&lang=js&"
import style0 from "./JcTicketDetails.vue?vue&type=style&index=0&id=336411f2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336411f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VContainer,VDialog,VForm,VIcon,VRow,VSpacer,VTextarea})
